// Profilové menu, potvrzovací řádky, vzhled, navigace.
// (Krok B1b: rozděleno ze src/app.js beze změny kódu; importy/exporty doplněny automaticky.)
import { appearance, saveAppearance } from './appearance.js';
import { applyAppearance, checkForAppUpdate } from './update.js';
import { esc, realRole, state } from './state.js';
import { render } from '../main-render.js';
import { routerBack } from './router.js';

// ---------- profilové kolečko + rozbalovací menu (Nastavení / Profil / Odhlásit se) ----------
function updateTopbarProfileButton(){
  var btn = document.getElementById('topbarProfileBtn');
  if(!btn || !state.myId) return;
  btn.style.display = 'flex';
  var scanBtn = document.getElementById('topbarScanBtn');
  if(scanBtn) scanBtn.style.display = 'flex';
  if(state.meAvatarUrl){
    btn.innerHTML = '<img src="'+esc(state.meAvatarUrl)+'"/>';
  } else {
    var initials = (state.meName||state.meEmail||'?').trim().charAt(0).toUpperCase() || '?';
    btn.style.background = state.meColor ? state.meColor : '';
    btn.textContent = initials;
  }
}
// Odhlášení — tady (ne v lazy Nastavení), aby fungovalo z menu profilu vždy
// (dřív bez otevřeného Nastavení tlačítko nereagovalo, 2026-11-01).
App.logout = function(){
  // Sign-out must reload the app even if the remote call fails or never
  // settles — e.g. the session/refresh token is already stale, or (on a
  // shaky mobile connection) the "revoke on server" request Supabase makes
  // for a default/global sign-out just hangs. The reload is what actually
  // returns the user to the login screen, so it must not depend on that
  // network round-trip completing: a short timeout forces it regardless.
  var done = false;
  function finish(){
    if(done) return; done = true;
    if(window.__sbAuth && window.__sbAuth.clearLocalSession) window.__sbAuth.clearLocalSession();
    // Data uložená pro práci bez signálu (IndexedDB) nesmí po odhlášení zůstat
    // v zařízení; neodeslané změny (fronta) zůstanou do dalšího přihlášení.
    var clear = (window.__sync && window.__sync.clearCache) ? window.__sync.clearCache() : Promise.resolve();
    Promise.race([clear, new Promise(function(r){ setTimeout(r, 800); })]).then(function(){ location.reload(); });
  }
  if(window.__sbAuth){
    window.__sbAuth.signOut().then(finish, finish);
    setTimeout(finish, 2500);
  } else {
    finish();
  }
};
App.toggleProfileMenu = function(e){
  if(e) e.stopPropagation();
  var menu = document.getElementById('profileMenu');
  if(!menu) return;
  var open = menu.style.display === 'block';
  // Účet a licence (portál) jen pro administrátora organizace.
  var portalBtn = document.getElementById('profilePortalBtn');
  if(portalBtn) portalBtn.style.display = realRole() === 'administrator' ? '' : 'none';
  menu.style.display = open ? 'none' : 'block';
};
// Portál BOZP-SOFTWARE: předplatné, licence, fakturační údaje (sdílené přihlášení).
App.openPortalAccount = function(){
  var base = (window.__licence && window.__licence.portalUrl) || 'https://bozp-software.cz';
  location.href = base + '/ucet/';
};
App.closeProfileMenu = function(){
  var menu = document.getElementById('profileMenu');
  if(menu) menu.style.display = 'none';
};
document.addEventListener('click', function(e){
  var wrap = document.querySelector('.topbar-profile-wrap');
  if(wrap && !wrap.contains(e.target)) App.closeProfileMenu();
});

// ---------- generic confirm ----------
function confirmRow(key, label, yesLabel, yesClass, wrapClass){
  if(state.confirmTarget === key){
    return '<div class="confirm-row'+(wrapClass?' '+wrapClass:'')+'"><span>'+esc(label)+'</span>' +
      '<button class="btn btn-sm '+(yesClass||'btn-danger')+'" onclick="App.__confirmYes()">'+esc(yesLabel||'Smazat')+'</button>' +
      '<button class="btn btn-sm btn-ghost" onclick="App.cancelConfirm()">Zrušit</button></div>';
  }
  return null;
}
var pendingConfirmFn = null;
window.App = window.App || {};
// Generic setter for inline onXXX="App.setStateField('foo', this.value)"
// handlers. Needed because "state" itself is local to this module's IIFE
// (not global) — an inline onXXX="state.foo=this.value" attribute is
// compiled against the *global* scope, so it can't see it and throws
// "state is not defined" the moment it fires, silently leaving the typed
// value never written to state (confirmed via isolated repro). No render()
// call here on purpose — these back plain text/select inputs that keep
// their own DOM value between renders, same as every other such field.
App.setStateField = function(key, value){
  state[key] = value;
};
App.askConfirm = function(key, fn){
  state.confirmTarget = key;
  pendingConfirmFn = fn;
  render();
};
App.__confirmYes = function(){
  var fn = pendingConfirmFn;
  state.confirmTarget = '';
  pendingConfirmFn = null;
  if(fn) fn();
};
App.cancelConfirm = function(){
  state.confirmTarget = '';
  pendingConfirmFn = null;
  render();
};

// ---------- appearance ----------
App.setTheme = function(theme){
  appearance.theme = theme;
  saveAppearance(appearance);
  applyAppearance();
  render();
};
App.setAccent = function(accent){
  appearance.accent = accent;
  saveAppearance(appearance);
  applyAppearance();
  render();
};
App.setFontSize = function(size){
  appearance.fontSize = size;
  saveAppearance(appearance);
  applyAppearance();
  render();
};
App.setColorblindMode = function(checked){
  appearance.colorblindMode = !!checked;
  saveAppearance(appearance);
  render();
};
App.setMyTasksEnabled = function(checked){
  appearance.myTasks = !!checked;
  saveAppearance(appearance);
  render();
};
App.setNavBadges = function(checked){
  appearance.navBadges = !!checked;
  saveAppearance(appearance);
  render();
};

// ---------- navigation ----------
// Přechod na jinou obrazovku: App.setView(v). Adresu stránky a historii
// prohlížeče (tlačítko Zpět) z toho odvozuje router.js po překreslení.
function resetViewState(v){
  state.view = v;
  state.historyDetailId = null;
  state.historyShowTrash = false;
  state.correctiveDetailId = null;
  state.correctiveAuditFilter = null;
  state.correctivePendingStatus = null;
  state.correctivePendingNote = '';
  state.correctivePendingAttachments = [];
  state.addFormOpen = null;
  state.editScheduleId = null;
  state.scheduleCalendarSelectedDay = null;
}
function applyView(v){
  resetViewState(v);
  render();
  checkForAppUpdate();
}
App.setView = function(v){
  applyView(v);
};
// Zpět = krok zpět v historii prohlížeče (adresy stránek, router.js);
// bez předchozího záznamu této relace výchozí obrazovka (fallback).
App.goBack = function(fallback){
  if(routerBack()) return;
  applyView(fallback || 'dashboard');
};

export {
  confirmRow,
  resetViewState,
  updateTopbarProfileButton
};
